import '@/bootstrap';

import {autoAnimatePlugin} from '@formkit/auto-animate/vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {createSSRApp, h} from 'vue';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import VueNumber from 'vue-number-animation';
import {createPinia} from 'pinia';
import {ZiggyVue} from '@/plugins/ziggy';
import {Ziggy} from '@/ziggy';
import dayjs from '@/plugins/dayjs';
import {flareVue} from '@flareapp/vue';
import flare from '@/plugins/flare';
import {setupVueWarningHandler} from '@/plugins/flareVueWarnings';
import VueEasyLightbox from 'vue-easy-lightbox';
import {createFormKitConfig, createLocaleI18n} from '@/localeConfig';
import {plugin as FKp} from '@formkit/vue';
import {createGtm} from '@gtm-support/vue-gtm';
import Notifications from 'notiwind';

const pinia = createPinia();

if (import.meta.env.PROD) {
    flare.light();
}

createInertiaApp({
    progress: {color: '#4F46E5', delay: 500},
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        const currentLocale = props.initialPage.props.locale;

        const i18n = createLocaleI18n(currentLocale, props.initialPage.props.main_locale);

        const app = createSSRApp({render: () => h(App, props)})
            .use(plugin)
            .use(pinia)
            .use(flareVue)
            .use(Notifications)
            .use(ZiggyVue, {...Ziggy, locale: currentLocale})
            .use(dayjs, {locale: currentLocale})
            .use(i18n)
            .use(VueNumber)
            .use(autoAnimatePlugin)
            .use(FKp, createFormKitConfig(currentLocale))
            .use(
                createGtm({
                    id: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
                    enabled: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ENABLED == 'true' && import.meta.env.PROD,
                }),
            )
            .use(VueEasyLightbox);

        // Setup Vue warning handler to track warnings in Flare
        setupVueWarningHandler(app);

        return app.mount(el);
    },
});
